import React, { ReactNode } from "react"
import Components from ".."
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import { blokType } from "../../types"
import { LinkBlokProps } from "../link"
import Link from "../global-header/Link"

import {
  StyledHero,
  StyledHeroContainer,
  StyledHeroCard,
  StyledHeroBreadcrumbs,
  StyledHeroTitle,
  StyledHeroDescription,
  StyledHeroButtons,
  StyledHeroAsset,
  StyledHeroHighlight,
  StyledVideo,
  StyledProgramLogoWrapper,
  StyledProgramLogo,
} from "./partials"

export interface HeroProps {
  breadcrumbs: LinkBlokProps[]
  program_logo: blokType[]
  title: string
  description: string
  cta_button: blokType[]
  hero_image: blokType[]
  content: blokType[]
  highlight_spacing: boolean
}

export const HeroCmp: React.FC<HeroProps> = ({
  breadcrumbs,
  program_logo,
  title,
  description,
  cta_button,
  hero_image,
  content,
  highlight_spacing,
}) => (
  <StyledHero data-name="hero">
    <StyledHeroContainer>
      <StyledHeroCard>
        {breadcrumbs && (
          <StyledHeroBreadcrumbs>
            {breadcrumbs.map((l) =>
              React.createElement(Components(l.component), {
                key: l._uid,
                blok: l,
              })
            )}
          </StyledHeroBreadcrumbs>
        )}
        {program_logo && (
          <StyledProgramLogoWrapper>
            {program_logo.map((content: any) => (
              <StyledProgramLogo hover_icon={content.hover_icon}>
                <Link
                  url={content.link}
                  target={content.target}
                  icon={content.icon}
                  hover_icon={content.hover_icon}
                />
              </StyledProgramLogo>
            ))}
          </StyledProgramLogoWrapper>
        )}
        {title && <StyledHeroTitle>{title}</StyledHeroTitle>}
        {description && (
          <StyledHeroDescription>
            {
              unified()
                .use(remarkParse)
                .use(remarkRehype)
                .use(rehypeReact as any, {
                  createElement: React.createElement,
                  components: remarkReactComponents,
                  Fragment: React.Fragment
                })
                .processSync(description.replace(/\n/g, "  \n"))
                .result as ReactNode
            }
          </StyledHeroDescription>
        )}
        {cta_button && cta_button.length > 0 && (
          <StyledHeroButtons>
            {cta_button.map((content) =>
              React.createElement(Components(content.component), {
                key: content._uid,
                blok: content,
              })
            )}
          </StyledHeroButtons>
        )}
      </StyledHeroCard>
      <StyledHeroAsset
        img={
          hero_image && hero_image.length > 0 && hero_image[0].media.filename
        }
        mobile_img={
          hero_image &&
          hero_image.length > 0 &&
          hero_image[0].mobile_image &&
          hero_image[0].mobile_image.filename
        }
        image_exists={hero_image.length > 0 && hero_image ? true : false}
      >
        {content && content.length > 0 && (
          <StyledHeroHighlight
            mobile_only={false}
            image_exists={hero_image.length > 0 && hero_image ? true : false}
            highlight_spacing={highlight_spacing}
          >
            {content.map((c) =>
              React.createElement(Components(c.component), {
                key: c._uid,
                blok: c,
              })
            )}
          </StyledHeroHighlight>
        )}
      </StyledHeroAsset>
      {content && content.length > 0 && (
        <StyledHeroHighlight
          highlight_spacing={highlight_spacing}
          mobile_only={true}
          image_exists={false}
        >
          {content.map((c) =>
            React.createElement(Components(c.component), {
              key: c._uid,
              blok: c,
            })
          )}
        </StyledHeroHighlight>
      )}
    </StyledHeroContainer>
  </StyledHero>
)
